/*
 * @Auther: 罗耀祖
 * @Date: 2022-07-27 16:40:04
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-07-27 16:49:30
 * @name: 工作流版本
 * @Description: 工作流版本
 * @FilePath: \preSaleNafterSaleBackstage\src\store\modules\flowVersion.js
 * @Author: desktop
 */
const state = {
  versions: [],
  now_version: {},
}

const mutations = {
  versionsChange(state, versions) {
    state.versions = versions;
  },
  nowVersionChange(state, now_version) {
    state.now_version = now_version;
  }
}

const actions = {
  versionsChange({ commit }, versions) {
    commit('versionsChange', versions);
  },
  nowVersionChange({ commit }, now_version) {
    commit('nowVersionChange', now_version);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}